import React, { useState } from "react";
import { documentRepo, storageService } from "../../services";
import { formatBytes } from "../../config/storage";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { useMockCustomer } from "./useMockCustomer";
import { Card, EmptyState, UploadBox, formatDate, useAsync } from "../../components/ui";
import Icon from "../../components/ui/Icon";

export default function CustomerDocuments() {
  const { orgId, toast, checkStorage } = useApp();
  const { tx } = useI18n();
  const { customer } = useMockCustomer(orgId);
  const { data: documents, reload } = useAsync(() => (customer ? documentRepo.all(orgId, (row) => row.customerId === customer.id) : Promise.resolve([])), [orgId, customer], []);
  const [preview, setPreview] = useState(null);

  const upload = async (file) => {
    // บล็อกถ้าไฟล์ใหม่ทำให้เกินโควตาที่เก็บไฟล์ของร้าน (อ่านยอดล่าสุดจากข้อมูลจริงทุกครั้ง)
    try {
      const check = checkStorage(await storageService.usedBytes(orgId), file.size);
      if (!check.ok) {
        toast(tx("พื้นที่เก็บไฟล์ของร้านเต็มแล้ว ไม่สามารถอัปโหลดได้ กรุณาติดต่อร้าน", `The shop's storage is full (${formatBytes(check.usedBytes)} used) — please contact the shop`), "error");
        return;
      }
    } catch (err) {
      toast(err.message, "error");
      return;
    }
    const reader = new FileReader();
    reader.onload = async () => {
      setPreview(reader.result);
      await documentRepo.create(orgId, {
        customerId: customer.id,
        customerName: customer.name,
        name: file.name,
        type: "other",
        size: `${Math.round(file.size / 1024)} KB`,
        sizeBytes: file.size,
        uploadedBy: "customer",
      });
      reload();
      toast(tx("อัปโหลดเอกสารเรียบร้อย", "Document uploaded"), "success");
    };
    reader.readAsDataURL(file);
  };

  return (
    <>
      <Card title={tx("อัปโหลดเอกสารใหม่", "Upload document")}>
        <UploadBox onFile={upload} preview={preview} hint={tx("อัปโหลดบัตรประชาชน ใบขับขี่ หรือเอกสารอื่น ๆ", "Upload ID card, driver's license or other documents")} />
      </Card>

      <Card title={tx("เอกสารของฉัน", "My documents")}>
        {!documents?.length ? (
          <EmptyState icon={<Icon name="folder" />} text={tx("ยังไม่มีเอกสาร", "No documents yet")} />
        ) : (
          documents.map((doc) => (
            <div key={doc.id} className="u-between" style={{ padding: "9px 0", borderBottom: "1px solid var(--c-slate-100)" }}>
              <div>
                <div className="u-fs-13 u-strong"><Icon name="folder" /> {doc.name}</div>
                <div className="u-fs-12 u-muted">{doc.size} · {formatDate(doc.createdAt)}</div>
              </div>
            </div>
          ))
        )}
      </Card>
    </>
  );
}
